export default __webpack_public_path__ + "static/oslobukta_logo-93e140e3ddb255f59d2419dcea23be57.png";